import Axios from 'axios';
import React, { Component } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import PrinterControls from './printerControls';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import Modal from '../components/modal';
import AdminPrinterInfo from './adminPrinterInfo';
import AdminPrinterChangeFilament from './adminPrinterChangeFilament';

class Printers extends Component {
    state = {
        extended: false,
        disableEnabled: true,
        showChangeFilament: false
    }
    toggleEnable = (id) => {
        this.setState({ disableEnabled: false })
        Axios.post("/api/printers/toggle/enabled", { id: id }).then(res => { })
    }
    componentDidUpdate(props, state) {
        if (props.data && this.props.data && props.data.printer && this.props.data.printer) {
            if (props.data.printer.enabled != this.props.data.printer.enabled) {
                this.setState({ disableEnabled: true })
            }
        }

    }

    formatTime = (seconds) => {
        if (!seconds || seconds < 0) return "00:00:00";
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        return [hrs, mins, secs]
            .map(v => String(v).padStart(2, "0"))
            .join(":");
    }
    changeFilament = () => {
        this.setState({showChangeFilament: true})
    }
    completedAction=()=>{
        Axios.post("/api/actions/complete", {printerId: this.props.data?.printer?._id, actionId: this.props.data?.printer?.action, jobId: this.props.data?.printer?.active_job})
    }

    render() {
        let printer = this.props.data
        if (!printer) {
            return (<div>Error</div>)
        }
        let enableBut
        if (printer) {
            enableBut = <Button disabled={!this.state.disableEnabled} onClick={() => this.toggleEnable(printer.printer._id)}>{printer.printer.enabled ? "Enabled" : "Disabled"}</Button>
        }



        const actualBed = printer?.info?.temperature?.bed?.actual;
        const targetBed = printer?.info?.temperature?.bed?.target || 1;
        const rawValueBed = (actualBed / targetBed) * 100;
        const overflowBed = rawValueBed > 100;
        const displayedBed = overflowBed ? rawValueBed - 100 : rawValueBed;

        const actualTool0 = printer?.info?.temperature?.tool0?.actual;
        const targetTool0 = printer?.info?.temperature?.tool0?.target || 1;
        const rawValueTool0 = (actualTool0 / targetTool0) * 100;
        const overflowTool0 = rawValueTool0 > 100;
        const displayedTool0 = overflowTool0 ? rawValueTool0 - 100 : rawValueTool0;

        return (<div>
            <Card style={{ width: "99%", margin: "auto", marginBottom: "100px", marginTop: "20px" }}>
                <Card.Header className={this.props.darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: "center" }}>
                    Printer: {printer.printer.printer_id}
                </Card.Header>
                {enableBut}
                <div style={{ width: "100%" }} className={this.props.darkmode ? "darkmode-card-content" : "lightmode-card-content"} >
                    <h3>
                        {printer.printer.brand} {printer.printer.model} @ {printer.printer.ip}
                    </h3>
                    <h3>
                        Job: {printer.printer.active_job} / {printer?.job?.job?.file?.name}
                    </h3>
                    <h3>
                        Action: {printer.printer.action} 
                    </h3>
                    <button onClick={this.completedAction}>Completed Action</button>
                    <Row style={{ margin: "auto", justifyContent: "center" }}>
                        <Col style={{ maxWidth: "210px" }}>
                            <CircularProgressbarWithChildren value={printer?.job?.progress?.completion} background={true} styles={{
                                path: {
                                    stroke: "blue",
                                    strokeLinecap: "round"


                                }, trail: {
                                    stroke: "black",
                                    strokeLinecap: "round"
                                },

                                background: { fill: "white" },
                            }}>
                                <p style={{ color: "black" }}>
                                    Print Progress
                                </p>
                                <p style={{ color: "black" }}>
                                    Total: {this.formatTime(printer?.job?.progress?.printTime)}
                                </p>

                                <p style={{ color: "black" }}>

                                    Left: {this.formatTime(printer?.job?.progress?.printTimeLeft)}

                                </p>

                            </CircularProgressbarWithChildren>

                        </Col>
                        <Col style={{ maxWidth: "210px" }}>
                            <CircularProgressbarWithChildren value={displayedBed} background={true} styles={{
                                path: {
                                    stroke: overflowBed ? "red" : "blue",
                                    strokeLinecap: "butt"


                                }, trail: {
                                    stroke: overflowBed ? "blue" : "black",
                                    strokeLinecap: "butt"
                                },

                                background: { fill: "white" },
                            }}>
                                <p style={{ color: "black" }}>
                                    Bed Temp
                                </p>
                                <p style={{ color: "black" }}>
                                    {printer?.info?.temperature?.bed?.actual} / {printer?.info?.temperature?.bed?.target}
                                </p>

                            </CircularProgressbarWithChildren>
                        </Col>
                        <Col style={{ maxWidth: "210px" }}>
                            <CircularProgressbarWithChildren value={displayedTool0} background={true} styles={{
                                path: {
                                    stroke: overflowTool0 ? "red" : "blue",
                                    strokeLinecap: "butt"


                                }, trail: {
                                    stroke: overflowTool0 ? "blue" : "black",
                                    strokeLinecap: "butt"
                                },

                                background: { fill: "white" },
                            }}>
                                <p style={{ color: "black" }}>
                                    Tool0 Temp
                                </p>
                                <p style={{ color: "black" }}>
                                    {printer?.info?.temperature?.tool0?.actual} / {printer?.info?.temperature?.tool0?.target}
                                </p>

                            </CircularProgressbarWithChildren>
                        </Col>
                    </Row>


                    <Row style={{ margin: "auto" }}>
                        <Col>
                            <h3>Filament: {printer.printer.filament_loaded}</h3>
                        </Col>
                        <Col>
                            <Button onClick={this.changeFilament}>Change</Button>
                        </Col>
                    </Row>

                    <PrinterControls data={this.props.data} />
                    <button style={{ margin: "10px", width: "90%", margin: "auto" }} onClick={() => this.setState({ extended: true })}>View</button>


                </div>
            </Card >
            <Modal close={() => this.setState({ extended: false })} show={this.state.extended} title="Printer Info" content={<AdminPrinterInfo printer={printer} />} />
            <Modal close={() => this.setState({ showChangeFilament: false })} show={this.state.showChangeFilament} title="Change Filament" content={<AdminPrinterChangeFilament close={() => this.setState({ showChangeFilament: false })} printer={printer} />} />
        </div >);

    }

}

export default Printers;